import React, { useState } from 'react';
import QuestionFlow from '../components/aptitude/QuestionFlow';
import { APTITUDE_TOPICS, APTITUDE_QUESTIONS } from '../data/aptitudeQuestions';

const LockIcon = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const AptitudePractice = () => {
  const [topicKey, setTopicKey] = useState(APTITUDE_TOPICS[0].key);
  const [qIndex, setQIndex] = useState(0);

  const questions = APTITUDE_QUESTIONS[topicKey] || [];
  const question = questions[qIndex];

  const selectTopic = key => { setTopicKey(key); setQIndex(0); };

  return (
    <>
      <style>{`
        .apt2-page { background: var(--bg); color: var(--text); min-height: 100vh; font-family: 'Satoshi', 'Inter', system-ui, sans-serif; padding-bottom: 100px; }
        .apt2-hero { text-align: center; padding: 100px 20px 40px; }
        .apt2-badge {
          display: inline-flex; align-items: center; gap: 8px; padding: 7px 16px 7px 10px; border-radius: 999px;
          background: var(--badge-pill-bg); border: 1px solid var(--badge-pill-border); color: var(--badge-pill-text);
          font-size: 12px; font-weight: 800; letter-spacing: 0.04em; text-transform: uppercase; margin-bottom: 18px;
        }
        .apt2-badge img { width: 16px; height: 16px; border-radius: 4px; display: block; }
        .apt2-title { font-family: 'Inter', sans-serif; font-size: clamp(30px, 4.2vw, 52px); font-weight: 800; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.12; }
        .apt2-title span { background: var(--grad-brand); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        .apt2-subtitle { font-size: clamp(14.5px, 1.7vw, 17px); color: var(--text-2); max-width: 620px; margin: 0 auto; line-height: 1.65; }

        .apt2-wrap { max-width: 1080px; margin: 0 auto; padding: 0 20px; }

        .apt2-tabs { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 22px; justify-content: center; }
        .apt2-tab {
          padding: 11px 22px; border-radius: 999px; font-size: 13.5px; font-weight: 700; cursor: pointer;
          border: 1.5px solid var(--border); background: var(--card-solid); color: var(--muted);
          font-family: 'Satoshi','DM Sans',sans-serif; transition: all 0.18s ease;
        }
        .apt2-tab.active { border-color: var(--v1); background: var(--grad-brand); color: #fff; }
        .apt2-tab.locked { opacity: 0.6; border-style: dashed; }
        .apt2-tab-soon { font-size: 9.5px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; opacity: 0.75; margin-left: 6px; }

        .apt2-toolbar {
          display: flex; align-items: center; justify-content: space-between; padding: 13px 20px;
          border-radius: 14px; background: var(--bg2); border: 1px solid var(--border); margin-bottom: 20px;
        }
        .apt2-qnav-btn {
          padding: 7px 14px; border-radius: 8px; font-size: 12.5px; font-weight: 700; cursor: pointer;
          border: 1.5px solid var(--border-strong); background: transparent; color: var(--muted);
          font-family: 'Satoshi','DM Sans',sans-serif;
        }
        .apt2-qnav-btn:disabled { opacity: 0.35; cursor: default; }

        .apt2-grid { display: grid; grid-template-columns: 1fr; gap: 20px; align-items: start; }
        .apt2-card {
          background: var(--card-solid); border: 1px solid var(--border); border-radius: 18px;
          padding: 26px; box-shadow: var(--shadow-card);
        }
        .apt2-card-solution { background: var(--bg2); }
        .apt2-card-locked, .apt2-card-empty {
          display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
          border-style: dashed; border-color: var(--border-strong); color: var(--muted); min-height: 220px;
        }

        .apt2-tagchip { padding: 4px 12px; border-radius: 6px; font-size: 11.5px; font-weight: 700; color: var(--muted); background: var(--bg3); border: 1px solid var(--border); }

        .apt2-option {
          display: flex; align-items: center; gap: 12px; text-align: left; width: 100%; box-sizing: border-box;
          padding: 13px 16px; border-radius: 12px; border: 1.5px solid var(--border-strong); background: var(--bg3);
          font-family: 'Satoshi','DM Sans',sans-serif;
        }
        .apt2-option-badge { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12.5px; font-weight: 800; flex-shrink: 0; }
        .apt2-option-mark { margin-left: auto; font-weight: 800; }

        .apt2-feedback { margin-top: 16px; padding: 12px 16px; border-radius: 12px; font-size: 13.5px; font-weight: 700; border: 1px solid; background: var(--bg3); }

        .apt2-navbtn {
          padding: 8px 16px; border-radius: 9px; font-size: 12.5px; font-weight: 700; cursor: pointer;
          border: 1.5px solid var(--border-strong); background: transparent; color: var(--muted);
          font-family: 'Satoshi','DM Sans',sans-serif;
        }
        .apt2-navbtn:disabled { opacity: 0.4; cursor: default; }
        .apt2-navbtn-primary { border: none; background: var(--grad-brand); color: #fff; }

        .apt2-trap { display: flex; gap: 10px; padding: 14px 16px; border-radius: 12px; margin: 18px 0; background: var(--bg3); border: 1px solid var(--border); }

        .apt2-altbtn {
          display: inline-flex; align-items: center; gap: 8px; padding: 10px 16px; border-radius: 10px;
          border: 1.5px solid var(--accent-2); background: transparent; color: var(--accent-2);
          font-size: 13px; font-weight: 700; cursor: pointer; font-family: 'Satoshi','DM Sans',sans-serif;
        }
        .apt2-altbtn[data-open="true"] { background: var(--accent-2); color: #04140f; }
        .apt2-altsteps { margin: 14px 0 0; padding: 16px 16px 16px 34px; border-radius: 12px; background: var(--bg3); border: 1px solid var(--border); }
        .apt2-altsteps li { font-size: 14px; line-height: 1.7; color: var(--text); margin-bottom: 8px; }
        .apt2-altsteps li:last-child { margin-bottom: 0; }

        .apt2-community { border-top: 1px solid var(--border); margin-top: 22px; padding-top: 20px; }
        .apt2-commentcard { padding: 12px 14px; border-radius: 10px; background: var(--bg3); border: 1px solid var(--border); }
        .apt2-textarea {
          width: 100%; padding: 12px 14px; border-radius: 10px; border: 1px solid var(--border-strong);
          background: var(--card-solid); color: var(--text); font-size: 13.5px; font-family: inherit;
          resize: vertical; margin-bottom: 10px; box-sizing: border-box;
        }

        @media (min-width: 900px) {
          .apt2-grid { grid-template-columns: 1.05fr 1fr; gap: 26px; }
        }
        @media (max-width: 640px) {
          .apt2-hero { padding: 84px 16px 32px; }
          .apt2-card { padding: 20px 16px; border-radius: 16px; }
          .apt2-tab { padding: 9px 16px; font-size: 12.5px; flex: 1 1 auto; text-align: center; }
        }
      `}</style>

      <div className="apt2-page">
        <section className="apt2-hero">
          <span className="apt2-badge"><img src="/favicon-32.png" alt="" />Quantitative Aptitude — Part 1</span>
          <h1 className="apt2-title"><span>Aptitude</span> Practice</h1>
          <p className="apt2-subtitle">
            Every question is solved for you step by step — not just an answer key. Plus a shortcut method for each one, and space for the community to share faster ways to solve it.
          </p>
        </section>

        <section className="apt2-wrap">
          <div className="apt2-tabs">
            {APTITUDE_TOPICS.map(t => (
              <button
                key={t.key}
                className={`apt2-tab ${topicKey === t.key ? 'active' : ''} ${t.comingSoon ? 'locked' : ''}`}
                onClick={() => selectTopic(t.key)}
              >
                {t.comingSoon && <LockIcon />} {t.label}
                {t.comingSoon && <span className="apt2-tab-soon">Soon</span>}
              </button>
            ))}
          </div>

          {question ? (
            <>
              <div className="apt2-toolbar">
                <button className="apt2-qnav-btn" onClick={() => setQIndex(i => i - 1)} disabled={qIndex === 0}>← Prev</button>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--muted)' }}>Question {qIndex + 1} of {questions.length}</span>
                <button className="apt2-qnav-btn" onClick={() => setQIndex(i => i + 1)} disabled={qIndex === questions.length - 1}>Next →</button>
              </div>
              <QuestionFlow question={{ ...question, topic: topicKey }} />
            </>
          ) : (
            <div className="apt2-card apt2-card-empty">
              <LockIcon size={22} />
              <p style={{ margin: '10px 0 0', maxWidth: 260 }}>
                {APTITUDE_TOPICS.find(t => t.key === topicKey)?.label} is coming soon — 25 hand-verified questions, same format as the topics already unlocked.
              </p>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default AptitudePractice;
